import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import Icons from "@/assets/icons";
import { FontFamilies } from "@/constants/Typography";

interface BenefitItemProps {
  text: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({ text }) => {
  return (
    <View style={styles.container}>
      <View style={styles.checkContainer}>
        <Icons.CheckCircle />
      </View>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
  },
  checkContainer: {
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  text: {
    fontSize: 13,
    color: "#1F2937",
    flex: 1,
    fontFamily: FontFamilies.Inter.Medium,
  },
});

export default BenefitItem;
